/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */

import dateUtil from '@bingads-webui-component-legacy/humanize/date';
import appState from '@bingads-webui-component-legacy/state/index';
import { getSegPreference, getSegType } from '@bingads-webui-component-legacy/bingads-grid/service/segmentation-preferences';
import segmentTimeChecker from '@bingads-webui-component-legacy/bingads-grid/shared/timeRangeChecker';
import { fetchPaginationConfig } from '@bingads-webui-component-legacy/bingads-grid/service/fetch-pagination';
import appConfig from '@bingads-webui-component-legacy/config/index';
import * as preferenceStoreFactory from '@bingads-webui-component-legacy/bingads-grid/service/filter-preferences';
import * as customColumnPreference from '@bingads-webui-component-legacy/bingads-grid/service/custom-column-preferences';
import dataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import sessionStore from '@bingads-webui-component-legacy/js-data-storage/session-storage';
import azureUrlRewrite from '@bingads-webui-static-legacy/app/component/azureUrlRewrite';
import { Account } from '@bingads-webui-campaign/campaign-ui-schemas';
import CacheService from '@bingads-webui-static-legacy/cache-service';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';


const accountSchema = Account;
const schemaI18nCampaign = window.globalLegacyI18n.get('$/schema-i18n!campaign');
const legacyGlobalI18n = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');
const accountSummaryi18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/accounts-summary');


export const lazyLoadDeps = {
  dateUtil,
  appState,
  getSegPreference,
  getSegType,
  segmentTimeChecker,
  fetchPaginationConfig,
  appConfig,
  accountSchema,
  schemaI18nCampaign,
  legacyGlobalI18n,
  accountSummaryi18n,
  preferenceStoreFactory,
  customColumnPreference,
  dataContextManager,
  jsData,
  sessionStore,
  azureUrlRewrite,
  CacheService,
  edm: edmCampaign,
};
